@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key) {
    <span
      >{{
        'common.LANGUAGE.' +
          getLanguageName($.row[$.adata.fetch_key]).toUpperCase() | translate
      }}
    </span>
  }
}
